import en from './en.json'
import it from './it.json'

export const siteTranslations = {
	en,
	it
} as const
